// extracted by mini-css-extract-plugin
export default {"items":"location-types-list_items__2w-WC"};